import { render, staticRenderFns } from "./AccountStatement.vue?vue&type=template&id=e20d80ae&"
import script from "./AccountStatement.vue?vue&type=script&lang=js&"
export * from "./AccountStatement.vue?vue&type=script&lang=js&"
import style0 from "./AccountStatement.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports